import { Form, Input, Space, Switch } from 'antd';
import styles from '../../Dashboard/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { createClient, selectConfigureSlice } from '../redux/slice';

export default function CreateClientModal({
  isOpen,
  setIsOpen,
  onAssign,
  data,
  name
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isEdit = typeof isOpen === 'number';
  const { loading } = useSelector(selectConfigureSlice);

  //   on modal close
  const handleClose = () => {
    isEdit ? setIsOpen(null) : setIsOpen(false);
    form.resetFields();
  };

  //after modal is closed
  const handleafterClose = () => {
    form.resetFields();
  };

  //init data
  useEffect(() => {
    if (isEdit && data) {
      form.setFieldsValue({
        client_name: data.client_name,
        is_active: data.is_active
      });
    }
  }, [isEdit, isOpen]);

  //   on finish
  const onFinish = (values) => {
    const payload = {
      ...values
    };
    if (isEdit) {
      payload.id = isOpen;
    }
    dispatch(createClient(payload)).then((res) => {
      if (res?.payload?.success) {
        handleClose();
        onAssign();
      }
    });
  };

  return (
    <CustomModal
      visible={isOpen}
      footer={null}
      className={`!w-full sm:!w-[40%] md:!w-[35%] lg:!w-[30%] xl:!w-[25%] ${styles.customModal}`}
      closable={false}
      centered
      afterClose={handleafterClose}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onValuesChange={handleFormValuesChange}
      >
        <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
          {isEdit ? 'Edit' : 'Add'} {name}
        </h3>

        <div className={'!mt-4 flex flex-col gap-2'}>
          <FormItem
            label="Client name"
            name="client_name"
            rules={[{ required: true, message: 'Client name is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Enter name" />
          </FormItem>
          {isEdit ? (
            <FormItem
              valuePropName="checked"
              name="is_active"
              label="Is active?"
              className={styles.customLable}
            >
              <Switch size="small" />
            </FormItem>
          ) : null}
        </div>
        <FormItem className="text-center">
          <Space style={{ marginTop: '20px' }}>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => handleClose()}
              type="primary"
              ghost
            >
              Cancel
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              type="primary"
              loading={loading}
            >
              {isEdit ? 'Update' : 'Add'} {name}
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
}
